import { useSubscription } from '@/features/subscription/hooks/useSubscription';

export type SubscriptionChannel = 'apple' | 'google' | 'stripe' | 'unknown';

export interface SubscriptionNotice {
  /** Nur ein eigenes Abo. Von einem Partner geteiltes Premium kann der Nutzer nicht kuendigen. */
  hasOwnSubscription: boolean;
  channel: SubscriptionChannel;
  /** Ende der bezahlten Laufzeit, soweit bekannt. */
  paidUntil: string | null;
  /** Nur bei Stripe fuehrt ein Link in der App zur Kuendigung. */
  canManageInApp: boolean;
}

/**
 * Woher das Abo kommt und was der Nutzer vor einer Kontoloeschung wissen
 * muss.
 *
 * Hintergrund: Abos ueber App Store und Google Play laufen bei uns ueber
 * RevenueCat. Wir koennen sie nicht beenden - weder ueber die App noch
 * durch das Loeschen des Kontos. Die bisherige Zusage in
 * profile:modals.deleteAccount.dataItem6 ("Dein Premium-Abonnement wird
 * gekuendigt") stimmte fuer diese Faelle nicht.
 */
export function useSubscriptionNotice(): SubscriptionNotice {
  const { isPremium, isSharedPremium, premiumSource, premiumExpiresAt, periodEnd } =
    useSubscription();

  const hasOwnSubscription = isPremium && !isSharedPremium;

  let channel: SubscriptionChannel = 'unknown';
  if (premiumSource === 'apple') channel = 'apple';
  else if (premiumSource === 'google') channel = 'google';
  else if (premiumSource === 'stripe') channel = 'stripe';

  return {
    hasOwnSubscription,
    channel,
    paidUntil: premiumExpiresAt || periodEnd || null,
    canManageInApp: channel === 'stripe',
  };
}
